import { useThemeProps as muiUseThemeProps } from '@mui/material/styles';
export function useThemeProps(options) {
    // ts-ignore to help with TS performance.
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return muiUseThemeProps(options);
}
